import { TranslationsKeys } from 'types/translation';
import { useTranslate } from 'hooks/useTranslate';
import styles from './Error500.module.scss';
import { Button } from '../../components/ui/Button';

const Error500 = () => {
  const { t } = useTranslate();
  return (
    <div className={styles.error500}>
      <img src="/assets/images/500.svg" alt=""/>
      <h1>{t(TranslationsKeys.error500_title)}</h1>
      <p>{t(TranslationsKeys.error500_text)}</p>
      <Button onClick={() => window.history.back()}>{t(TranslationsKeys.error500_back)}</Button>
    </div>
  );
};

export default Error500;